export const getInitial = (valeur = "") => {
  if (!valeur) return "?";
  return valeur.trim().charAt(0).toUpperCase();
};
